export const title = {
    'en': 'Google Maps (Experimental)',
    'zh-tw': 'Google Maps (實驗性)'
};

export const recordMarker1 ={
    'en': 'mark location [label] at longitude [lng] and latitude [lat] coordinates',
    'zh-tw': '標記名稱[label]經度[lng]緯度[lat]的座標'
}

export const recordMarker2 ={
    'en': 'The coordinates of the marker named [label] with longitude [lng], latitude [lat], and color code [color]',
    'zh-tw': '標記名稱[label]經度[lng]緯度[lat]顏色色碼[color]的座標'
}

export const recordMarker3 ={
    'en': 'The coordinates of the marker named [label] with longitude [lng], latitude [lat], and color code [color]',
    'zh-tw': '標記名稱[label]經度[lng]緯度[lat]顏色色碼[color]的座標'
}

export const recordMarker4 ={
    'en': 'The coordinates of labeled point [label] with longitude [lng], latitude [lat], and photo link [photo]',
    'zh-tw': '標記名稱[label]經度[lng]緯度[lat]圖片連結[photo]的座標'
}

export const tmpLabel = {
    'en': 'Fo Guang University',
    'zh-tw': '佛光大學'
}

export const showMarker1 ={
    'en': 'show on google maps',
    'zh-tw': '顯示在 Google 地圖'
}

export const calculateDistance = {
    'en':'window [display] selection [traffic] calculate the distance between two points',
    'zh-tw': '視窗[display]選擇[traffic]交通方式計算兩點的距離'
}

export const setFieldNames ={
    'en': 'set Name [name], Longitude [longitude], Latitude [latitude], and Description [note] fields',
    'zh-tw': '設定名稱[name]經度[longitude]緯度[latitude]及備註[note]等欄位名稱'
}

export const setFieldNames2 ={
    'en': 'set image length to [length]px, width to [width]px',
    'zh-tw': '設定圖片長度[length]px 寬度[width]px'
}

export const showMarker2 ={
    'en': 'import data [data] and show on google maps',
    'zh-tw': '從資料[data]標記座標顯示在 Google 地圖'
}

export const showMarker3 ={
    'en': 'import data [data] and show on google maps',
    'zh-tw': '從資料[data]標記座標顯示在 Google 地圖'
}

export const showMarker4 ={
    'en': 'import data [data] and show on google maps',
    'zh-tw': '從資料[data]標記座標顯示在 Google 地圖'
}

export const tmpData1 = {
    'en': 'name, longitude, latitude, note',
    'zh-tw': '名稱,經度,緯度,備註'
}

export const tmpData2 = {
    'en': 'name, longitude, latitude, color, note',
    'zh-tw': '名稱,經度,緯度,顏色,備註'
}

export const tmpData3 = {
    'en': 'name, longitude, latitude, image link, note',
    'zh-tw': '名稱,經度,緯度,圖片連結,備註'
}

export const readErr = {
    'en': 'Error: no data on distance between two points',
    'zh-tw': '錯誤：沒有兩點距離的資料'
}

export const distance = {
    'en': 'distance',
    'zh-tw': '距離'
}

export const name = {
    'en': 'name',
    'zh-tw': '名稱'
}

export const longitude = {
    'en': 'longitude',
    'zh-tw': '經度'
}

export const latitude = {
    'en': 'latitude',
    'zh-tw': '緯度'
}

export const note = {
    'en': 'note',
    'zh-tw': '備註'
}

export const red = {
    'en': 'red',
    'zh-tw': '紅色'
}

export const yellow = {
    'en': 'yellow',
    'zh-tw': '黃色'
}

export const green = {
    'en': 'green',
    'zh-tw': '綠色'
}

export const blue = {
    'en': 'blue',
    'zh-tw': '藍色'
}

export const driving = {
    'en': 'driving',
    'zh-tw': '開車'
}

export const transit = {
    'en': 'transit',
    'zh-tw': '大眾運輸'
}

export const walking = {
    'en': 'walking',
    'zh-tw': '步行'
}

export const open = {
    'en': 'open',
    'zh-tw': '開啟'
}

export const close = {
    'en': 'close',
    'zh-tw': '關閉'
}